import React from 'react';
import WedgeIcon from "@/components/icons/WedgeIcon";

const SummaryCategoryStats = ({icon, label='Category', color='bg-opacity-0', pieColor='white', played=0, collected=0, average=0}) => {
	return <div className={`grid grid-cols-5 ${color} items-center rounded-lg w-full font-gSemi lg:text-md md:text-xs text-xxs px-3 py-1`}>
		<div className={'grid grid-cols-3 items-center justify-end'}>
			{!!icon && <div className={'w-12 pr-2 flex justify-center items-center'}>{icon}</div>}
			<div className={'flex uppercase flex-grow w-full whitespace-nowrap col-start-3 text-xs'}>{label}</div>
		</div>
		<div className={'flex items-center justify-end col-start-4'}>
			<span className={'pr-2 text-xs'}>{collected} / {played}</span>
			<WedgeIcon color={pieColor}/>
		</div>
		<div className={'flex justify-end flex-shrink col-start-5 text-xs'}>{Math.round(average * 100)}%</div>
	</div>
}

export default SummaryCategoryStats;
